<template>
    <div :class="{'form-group': !skinnyMode, 'form-group-skinny': skinnyMode, 'invisible' : field.hide }" data-id="form-checkbox">
        <div class="custom-control custom-checkbox" :class="{'is-checked': field.value, 'help-visible': uiStates.helpBlockVisible,'is-disabled': field.disabled, 'has-help-block': (typeof field.helpBlock !== 'undefined') && (field.helpBlock.length > 0)}">
            <input v-model="field.value" :name="field.name" :id="field.name" class="custom-control-input" :value="field.value" type="checkbox" :disabled="field.disabled">
            <label class="custom-control-label" :class="{'border': hasBorder, 'border-0': !hasBorder}" :for="field.name">
                <span class="label-title">{{field.label}}<span v-if="field.required" class="required-field">*</span></span>
                <transition name="helpblock">
                    <span v-if="uiStates.helpBlockVisible" class="help-block-copy">{{field.helpBlock}}</span>
                </transition>
            </label>
            <div @click.prevent="uiStates.helpBlockVisible = !uiStates.helpBlockVisible" v-if="(typeof field.helpBlock !== 'undefined') && (field.helpBlock.length > 0)" class="show-help-block">
                <i v-if="uiStates.helpBlockVisible" class="fas fa-times-circle"></i>
                <i v-else class="fas fa-question-circle"></i>
            </div>
        </div>
        <small v-if="(this.activeLanguage !== 0) && (typeof masterValue !== 'undefined')" class="form-text text-muted">Master Value: {{ masterValue }}</small>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'

    Vue.use(VueEvents)

    export default {
        name: 'form-input-checkbox',
        props: {
            FieldData:Object,
            masterValue: String,
            activeLanguage: Number,
            skinnyMode: {
                type: Boolean,
                default: false
            },
            hasBorder: {
                type: Boolean,
                default: true,
            }
        },
        components:{
        },
        data() {
            return {
                uiStates: {
                    helpBlockVisible:false,
                    message:"",
                    messageClass:"",
                },
                field: this.FieldData,
            }
        },
        mounted() {
            this.$emit('input', this.field.value);
        },
        created() {

        },
        watch: {

        },
        methods: {

        }
    };
</script>

<style scoped lang="scss">
    .form-group {
        margin-top: 27px;
        min-height: 38px;
        position: relative;
    }
    .form-group-skinny {
        margin-top: 5px;
        margin-bottom: 5px;
        min-height: 38px;
        position: relative;
    }
    .helpblock-enter-active, .helpblock-leave-active {
      transition: all .5s;
      max-height: 150px;
    }
    .helpblock-enter, .helpblock-leave-to {
      opacity: 0;
      max-height: 0px;
    }
    .required-field{
        font-size: 16px;
        line-height: 0;
        color: #AB5755;
        position: relative;
        top: -4px;
    }
    .custom-checkbox{
        transition: box-shadow 0.2s linear;
        padding-left: 0px;
        background-color: #fff;
        &.has-help-block{
            width:100%;
            z-index: 2;
            overflow: hidden;
            position: absolute;
        }
        &.is-checked{
            label{
                border-color: #02A7CD;
                background-color: #E5F6FA;
            }
            .show-help-block{
                color:#02A7CD;
            }
        }
        &.is-disabled{
            label{
                border-color: #DEDEDE;
                background-color: #eeeeee;
                pointer-events: none;
            }
            .show-help-block{
                color:#A6A6A6;
            }
        }
        &.help-visible{
            transition: box-shadow 0.2s linear;
            box-shadow: 0 0 4px 0 rgba(129,126,126,0.25);
            .show-help-block{
                color:#AB5755;
            }
        }
    }
    label{
        position: relative;
        border-color: #DEDEDE;
        border-radius: 2px !important;
        display: block;
        padding: 9px 9px 8px 40px;
        &:before, &:after{
            top: 9px !important;
            left: 10px !important;
        }
    }
    .label-title{
        display: block;
    }
    .help-block-copy{
        display: block;
        margin-top: 2px;
        font-size: 10px;
        color: #000000;
        letter-spacing: 0;
    }
    .show-help-block{
        position: absolute;
        top: 8px;
        right: 10px;
        font-size: 15px;
        color:#A6A6A6;
        cursor: pointer;
    }
    .custom-checkbox > .custom-control-input:checked ~ .custom-control-label:before{
        background: #02a7cd;
        border-color: #02a7cd;
        border-radius: 2px
    }
    .custom-checkbox.is-disabled > .custom-control-input:checked ~ .custom-control-label:before{
        background: #A6A6A6;
        border-color: #A6A6A6;
        border-radius: 2px
    }
    .custom-checkbox > .custom-control-input:checked ~ .custom-control-label:after{
        color: #fff;
        content: "\f00c";
        top: 11px !important;
        left: 11px !important;
        font-size: 12px;
        font-weight: bold;
        font-family: "Font Awesome 5 Free";
        background-image:none !important;
    }
</style>
